export default "__VITE_ASSET__CmkR0ztS__"